import { HoleInfoModel } from '../models/CourseModels';

interface CalcNetScoreParams {
    holesToPlay: 'front9' | 'back9' | 'all18';
    grossScore: number | null;
    holeInfo: HoleInfoModel;
    handicap: number;
}

export const calcStrokesGiven = (handicap: number, holeInfo: HoleInfoModel, holesToPlay: 'front9' | 'back9' | 'all18') => {
    const is18Holes = holesToPlay === 'all18';
    const baseHandicap = is18Holes ? 18 : 9;
    const holeHandicap = is18Holes ? holeInfo.mensHandicap18 || 0 : holeInfo.mensHandicap9 || 0;
    let strokes = 0;

    if (holeHandicap <= Math.abs(handicap)) {
        if (handicap < 0) {
            // Negative handicap ranges
            if (handicap <= -holeHandicap) { // 0 thru -18 or 0 thru -9
                strokes--;
            }
            if (handicap <= -holeHandicap - baseHandicap) { // -19 thru -36 or -10 thru -18
                strokes--;
            }
        } else {
            // Positive handicap ranges
            if (handicap >= holeHandicap) { // 0 thru 18 or 0 thru 9
                strokes++;
            }
            if (handicap >= holeHandicap + baseHandicap) { // 19 thru 36 or 10 thru 18
                strokes++;
            }
            if (handicap >= holeHandicap + (2 * baseHandicap)) { // 37 thru 54 or 19 thru 27
                strokes++;
            }
            if (handicap >= holeHandicap + (3 * baseHandicap)) { // 55 thru 72 or 28 thru 36
                strokes++;
            }
        }
    }
    return strokes;
}

export const calcNetScore = ({ holesToPlay, grossScore, holeInfo, handicap }: CalcNetScoreParams): number | null => {
    if (grossScore === null || grossScore === undefined) {
        return null;
    }

    const strokes = calcStrokesGiven(handicap, holeInfo, holesToPlay);

    return grossScore - strokes;
}; 